<template>
  <div class="tab-menu-wrapper">
    <div class="tab-container">
      <ul class="tab-menu">
        <li
          v-for="tab in tabs"
          :key="tab.id"
          :class="['tab-item', { active: tab.id === activeTab }]"
          @click="$emit('update:activeTab', tab.id)"
        >
          <span class="tab-icon">
            <IconSvg :name="tab.icon" size="sm" />
          </span>
          <span class="tab-label">{{ tab.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconSvg from "./IconSvg.vue";

export default {
  name: "TabMenu",
  components: {
    IconSvg,
  },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },
  emits: ["update:activeTab"],
};
</script>

<style scoped>
.tab-menu-wrapper {
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border-light);
  box-shadow: var(--shadow-sm);
}

.tab-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.tab-menu {
  display: flex;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tab-menu::-webkit-scrollbar {
  display: none;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.875rem 1.25rem;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  color: var(--color-text-muted);
  font-weight: 500;
  font-size: 0.875rem;
  border-bottom: 2px solid transparent;
  transition: color var(--transition-fast), border-color var(--transition-fast);
}

.tab-item:hover {
  color: var(--color-text);
}

.tab-item.active {
  color: var(--color-text);
  border-bottom: 2px solid var(--primary-hover);
  font-weight: 600;
}

.tab-icon {
  font-size: 1.25rem;
}

.tab-label {
  font-size: 0.9375rem;
}

/* レスポンシブ */
@media (max-width: 640px) {
  .tab-item {
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
  }

  .tab-icon {
    font-size: 1.125rem;
  }

  .tab-label {
    font-size: 0.875rem;
  }
}
</style>
